import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";

/**
 * Manually trigger a reminder ("relance") immediately.
 *
 * Calls the backend, which sends the reminder email right now, records the
 * last send timestamp, increments the counter and reschedules the next trigger.
 *
 * @param {string} jobId - The job document id.
 * @param {string} prefix - API endpoint prefix.
 * @returns {Promise<{last_sent: string, trigger_date: string}>} - Resolves with the new send/trigger dates.
 * @throws {Error} - When the request fails (rejected so callers can show an error).
 */
const triggerJobReminder = async (jobId, prefix) => {
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}jobs/trigger`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ job_id: jobId }),
  });

  if (!response.ok) {
    let detail = "";
    try {
      const data = await response.json();
      detail = data?.detail || "";
    } catch (e) {
      // response body was not JSON; keep detail empty
    }
    throw new Error(detail || `Failed to trigger reminder: ${response.status}`);
  }

  return response.json();
};

export default triggerJobReminder;
